import * as React from "react";
import User from "../../../../../model/user/User";
import {Option} from "ts-option";
import {getUser} from "../../../../../store/view/user";
import {connect} from "react-redux";
import {RootState} from "../../../../../store/reducer/root/RootState";
import {AuthenticatedEntityTypeEnum} from "../../../../../model/user/AuthenticatedEntity";
import {getIndividualContact} from "../../../../../store/view/contact";
import IndividualContact from "../../../../../model/contact/IndividualContact";


interface IPresenterProps {
	/**
	 * User Id
	 */
	userId: string;
	/**
	 * Authenticated entity type
	 */
	type: AuthenticatedEntityTypeEnum;
}

interface IReduxProps {
	/**
	 * User
	 */
	user: Option<User>;
	/**
	 * Individual contact
	 */
	individualContact: Option<IndividualContact>
}

type PresenterProps = IPresenterProps & IReduxProps;

class CreatorPresenterComponent extends React.PureComponent<PresenterProps> {
	render() {
		return (
			<div>
				{this.getUserDisplayName()}
			</div>
		);
	}

	getUserDisplayName(): string {
		if (this.props.type == AuthenticatedEntityTypeEnum.User) {
			return this.props.user.map(u => u.getDisplayName()).getOrElse(`${this.props.type}: ${this.props.userId}`);
		}
		else if (this.props.type == AuthenticatedEntityTypeEnum.Customer) {
			return this.props.individualContact.map(ic => ic.data.displayName()).getOrElse(
				`${this.props.type}: ${this.props.userId}`);
		}
		else {
			return this.props.type;
		}
	}
}

function mapStateToProps(state: RootState, props: IPresenterProps) {
	return {
		user: getUser(props.userId),
		individualContact: getIndividualContact(props.userId, state)
	}
}

export default connect<IReduxProps, null, IPresenterProps>(mapStateToProps)(CreatorPresenterComponent);